<template>
    <v-layout justify-center class="pa-4">
        <v-responsive width="100%" height="100%">
            <list-heading title="추천인 정책" />

            <v-row class="ma-n2 mt-n1">
                <v-col class="pa-2" cols="12">
                    <user-code-table
                        v-model="codes"
                        v-bind="{
                            loading,
                            tempIdOnEdit,
                        }"
                        v-on="{
                            save: update,
                            pull: remove,
                            setTempIdOnEdit,
                        }"
                    />
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initUserCode } from "@/store/user-codes";

import ListHeading from "@/components/console/dumb/list/list-heading.vue";
import UserCodeTable from "@/components/console/user/user-code-table.vue";

export default {
    components: {
        ListHeading,
        UserCodeTable,
    },
    data: () => ({
        codes: [],

        loading: false,
        tempIdOnEdit: null,
    }),
    computed: {
        params() {
            let { ...query } = this.$route.query;

            query.depth = 1;

            return { ...query };
        },
    },
    methods: {
        async init() {
            this.codes = [];
            this.loading = false;

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { params } = this;
                let { summary, codes } = await api.console.user.codes.gets({
                    params,
                });

                this.summary = summary;
                this.codes = codes.map((code, index) =>
                    initUserCode({
                        ...code,
                        index: index + 1,
                    }),
                );
            } finally {
                this.loading = false;
            }
        },

        async update(item) {
            if (this.loading) return;
            else this.loading = true;
            try {
                let isCreate = !item?._id;
                let { post, put } = api.console.user.codes;
                let { code } = await (isCreate ? post : put)(item);
                code = initUserCode({ ...code, tempId: item.tempId });
            } finally {
                this.loading = false;
                this.tempIdOnEdit = null;
                this.search();
            }
        },

        async remove(code) {
            let go = confirm("해당 정책을 삭제하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await api.console.user.codes.delete(code);
                this.loading = false;
                await this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        setTempIdOnEdit(tempId = null) {
            this.tempIdOnEdit = tempId;
        },
    },
    watch: {
        params() {
            this.search();
        },
        tempIdOnEdit() {
            if (!this.tempIdOnEdit) this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .vertical-align-top {
        vertical-align: top !important;
    }
    .vertical-align-middle {
        vertical-align: middle !important;
    }
}
</style>
